// Documentation module translations - French (Français)
export const documentationFR = {
  // Common
  'Documentation': 'Documentation',
  'Need Help?': 'Besoin d\'Aide?',
  'Email': 'Email',
  'Documentation Center': 'Centre de Documentation',
  'Check other guides in the Documentation Center': 'Consultez d\'autres guides dans le Centre de Documentation',
  'If you have questions about payment modes or booking management, our support team is here to help:':
    'Si vous avez des questions sur les modes de paiement ou la gestion des réservations, notre équipe de support est là pour vous aider:',

  // Categories
  'Studio Bookings': 'Réservations de Studio',
  'Event Setup': 'Configuration d\'Événements',
  'Tickets & Pricing': 'Billets et Tarifs',

  // Payment Mode Documentation
  'Payment Mode Management Guide': 'Guide de Gestion des Modes de Paiement',
  'This comprehensive guide explains how to configure payment modes for your studio bookings and manage the booking approval workflow. Payment modes control how customers pay for their bookings and when money is collected.':
    'Ce guide complet explique comment configurer les modes de paiement pour les réservations de votre studio et gérer le flux d\'approbation des réservations. Les modes de paiement contrôlent comment les clients paient leurs réservations et quand l\'argent est collecté.',

  // Overview Section
  'Overview: Understanding Payment Modes': 'Aperçu: Comprendre les Modes de Paiement',
  'The system supports four different payment modes, each designed for different business needs:':
    'Le système prend en charge quatre modes de paiement différents, chacun conçu pour différents besoins commerciaux:',

  // Payment Modes
  'Manual Mode': 'Mode Manuel',
  'Full Payment Mode': 'Mode Paiement Complet',
  'Deposit Mode': 'Mode Acompte',
  'Hold Mode': 'Mode Autorisation',

  // Payment Mode Labels
  'No online payment': 'Pas de paiement en ligne',
  'Instant charge': 'Charge instantanée',
  'Partial charge': 'Charge partielle',
  'Authorization hold': 'Autorisation de retenue',

  // Payment Mode Descriptions
  'Customer submits booking request without paying online. Owner approves, then collects payment later (cash, invoice, etc.)':
    'Le client soumet une demande de réservation sans payer en ligne. Le propriétaire approuve, puis collecte le paiement plus tard (espèces, facture, etc.)',
  'Customer pays 100% upfront via online payment. Booking is automatically confirmed once payment succeeds.':
    'Le client paie 100% à l\'avance via paiement en ligne. La réservation est automatiquement confirmée une fois le paiement réussi.',
  'Customer pays a deposit upfront (e.g., 30%). Remaining balance collected later (before/after session).':
    'Le client paie un acompte à l\'avance (par ex., 30%). Le solde restant est collecté plus tard (avant/après la session).',
  'Card is authorized but NOT charged. Owner approves booking → money is captured. Owner rejects → hold is released.':
    'La carte est autorisée mais NON débitée. Le propriétaire approuve la réservation → l\'argent est capturé. Le propriétaire rejette → l\'autorisation est libérée.',

  // Configuration Section
  'How to Configure Payment Settings': 'Comment Configurer les Paramètres de Paiement',
  'Payment settings are configured per studio in the Manage Settings page under the Pricing & Payment tab. Navigate to: Studios → [Your Studio] → Manage Settings → Pricing & Payment':
    'Les paramètres de paiement sont configurés par studio dans la page Gérer les Paramètres sous l\'onglet Tarifs et Paiements. Naviguez vers: Studios → [Votre Studio] → Gérer les Paramètres → Tarifs et Paiements',

  // Configuration Steps
  'Access Payment Settings': 'Accéder aux Paramètres de Paiement',
  'Select Payment Mode': 'Sélectionner le Mode de Paiement',
  'Configure Deposit Settings (if using Deposit Mode)': 'Configurer les Paramètres d\'Acompte (si vous utilisez le Mode Acompte)',
  'Configure Booking Rules': 'Configurer les Règles de Réservation',
  'Save Your Changes': 'Sauvegarder vos Modifications',

  // Booking Management
  'Managing Booking Requests': 'Gestion des Demandes de Réservation',
  'Understanding Booking Statuses': 'Comprendre les États de Réservation',
  'Understanding Payment Statuses': 'Comprendre les États de Paiement',

  // Workflow
  'Workflow: Approving Bookings (Manual & Hold Modes)': 'Flux de Travail: Approbation des Réservations (Modes Manuel et Autorisation)',
  'View Pending Approvals': 'Voir les Approbations en Attente',
  'Review Booking Details': 'Examiner les Détails de Réservation',
  'Approve the Booking': 'Approuver la Réservation',
  'Reject the Booking (if needed)': 'Rejeter la Réservation (si nécessaire)',

  // Best Practices
  'Best Practices & Tips': 'Meilleures Pratiques et Conseils',
  'Choose the Right Mode for Your Business': 'Choisissez le Bon Mode pour Votre Entreprise',
  'Respond to Booking Requests Quickly': 'Répondez Rapidement aux Demandes de Réservation',
  'Provide Clear Rejection Reasons': 'Fournissez des Raisons de Rejet Claires',
  'Set Appropriate Deposit Amounts': 'Définissez des Montants d\'Acompte Appropriés',
  'Monitor Your Booking Dashboard': 'Surveillez votre Tableau de Bord de Réservations',
  'Track Your Revenue': 'Suivez vos Revenus',

  // Quick Reference
  'Quick Reference: Payment Mode Comparison': 'Référence Rapide: Comparaison des Modes de Paiement',

  // Table Headers and Common Terms
  'Status': 'Statut',
  'What It Means': 'Ce que cela Signifie',
  'Payment Status': 'Statut de Paiement',
  'Actions Available': 'Actions Disponibles',
  'Feature': 'Fonctionnalité',
  'Manual': 'Manuel',
  'Full Payment': 'Paiement Complet',
  'Deposit': 'Acompte',
  'Hold': 'Autorisation',
  'Best For': 'Idéal Pour',
  'Mode': 'Mode',

  // Payment Statuses
  'Unpaid': 'Non Payé',
  'Pending': 'En Attente',
  'On Hold': 'En Autorisation',
  'Deposit Paid': 'Acompte Payé',
  'Paid': 'Payé',
  'Refunded': 'Remboursé',

  // Booking Statuses
  'Pending Approval': 'En Attente d\'Approbation',
  'Confirmed': 'Confirmé',
  'In Progress': 'En Cours',
  'Completed': 'Terminé',
  'Rejected': 'Rejeté',
  'Cancelled': 'Annulé',
  'No Show': 'Absent',

  // Actions
  'Approve': 'Approuver',
  'Reject': 'Rejeter',
  'View': 'Voir',
  'Cancel': 'Annuler',
  'Mark In Progress': 'Marquer En Cours',
  'Mark Completed': 'Marquer Terminé',
  'Collect Balance': 'Collecter le Solde',

  // Common Descriptions
  'No payment received yet. Common in manual mode bookings before collection.':
    'Aucun paiement reçu pour le moment. Courant dans les réservations en mode manuel avant collecte.',
  'Payment initiated but not completed. Customer in checkout process.':
    'Paiement initié mais non terminé. Client en processus de paiement.',
  'Full payment received and confirmed. No balance owed.':
    'Paiement complet reçu et confirmé. Aucun solde dû.',
  'Payment was refunded back to customer (full or partial refund).':
    'Le paiement a été remboursé au client (remboursement total ou partiel).',
};
